export const colorsBackground = [
  '#FFBFD4',
  '#D40000',
  '#FA72A0',
  '#617EFF',
  '#FF6567',
  '#B35CFF',
]

export const colorsFonts = [
  '#74694E',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
